<!--
 * @Author: DQL
 * @Date: 2022-10-01 11:20:41
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 14:40:39
 * @Description: 评估明细
-->
<template>
  <!-- 查询条件 Start -->
  <div
    class="l-page--inner l-page--search"
  >
    <div
      class="l-page__item u-mg-b-10"
    >
      <el-form
        ref="filterParams"
        class="c-form c-condition__form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="78px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="9"
          >
            <el-form-item
              class="c-form__item"
              label="评估状态"
              prop="pgzt"
            >
              <el-radio-group v-model="filterParams.pgzt">
                <el-radio label="">
                  全部
                </el-radio>
                <el-radio label="Y">
                  已完成
                </el-radio>
                <el-radio label="N">
                  未完成
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="8"
          >
            <el-form-item
              class="c-form__item"
              label="类型"
              prop="lx"
            >
              <el-select
                v-model="filterParams.lx"
                clearable
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in lxType"
                  :key="item.id"
                  :value="item.id"
                  :label="item.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col o-form-btns"
            :span="7"
          >
            <k-button
              btn-text="查询"
              :auth-type="false"
              type="primary"
              icon="kestrel-icon ki-search"
              @click="refreshSearch()"
            />
            <k-button
              btn-text="重置"
              :auth-type="false"
              icon="kestrel-icon ki-repeat"
              @click="resetForm()"
            />
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 查询条件 End -->
    <!-- 页面主内容：查询列表 Start -->
    <div
      class="l-page__body l-page--search__body"
    >
      <!-- tips：l-page__tabs--single类用于只有一个tab时修饰页面使用 -->
      <!-- table的ref的命名根据业务名称修改 -->
      <k-table
        ref="kTable"
        height="100%"
        :table-column="tableColumn"
        :pagination-show="true"
        :tooltip-effect="null"
        :data="page.rows"
        :pagination="page"
        @current-change="search"
        @size-change="handleSizeChange"
      >
        <template
          #pdjg="scope"
        >
          {{ scope.row.pdjg || '/' }}
        </template>
        <template
          #df="scope"
        >
          {{ scope.row.df || '/' }}
        </template>
      </k-table>
    </div>
  </div>
</template>

<script>
import { pgxmManageService } from '../pgxm.service.js';
export default {
  name: 'PgxmList',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      xmid: null,
      loading: false, // 页面是否加载

      // 查询条件
      filterParams: {
        lx: null,
        pgzt: ''
      },
      /* 表格列配置Start */
      tableColumn: [
        { key: 'index', label: '序号', align: 'center', width: this.$commonConfig.tableWidthConfig.common_xh, type: 'index' },
        { key: 'dxzbMc', label: '单项名称', align: 'left', minWidth: '80', type: 'text' },
        { key: 'zxzbMc', label: '子项名称', align: 'left', width: '120', type: 'text' },
        { key: 'jcnrMc', label: '检查内容', align: 'left', width: '80', type: 'text' },
        { key: 'jcxz', label: '检查细则', align: 'left', minWidth: '280', type: 'text' },
        { key: 'bh', label: '条文编号', align: 'left', width: '80', type: 'text' },
        { key: 'jcqk', label: '检查情况', align: 'left', width: '80', type: 'text' },
        { key: 'pdjg', slotName: 'pdjg', label: '评定结果', align: 'left', width: '80', type: 'text' },
        { key: 'df', slotName: 'df', label: '评定分数', align: 'left', width: '80', type: 'text' }

      ],
      /* 表格列配置End */
      /* 分页实际查询条件（避免查询条件的双向绑定导致点击分页按钮，获取到的数据不符合真实过滤条件） Start */
      trueFilterParams: {},
      /* 分页实际查询条件 End */

      /* 查询结果 Start */
      page: {
        rows: [],
        total: 0,
        pageSize: 15,
        pageNo: 0
      }
      /* 查询结果 End */
    };
  },
  computed: {
    lxType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_AQLB) {
        return enums.IFF_AQLB;
      }
      return {};
    }
  },
  methods: {
    /**
     * @description: 记录分页查询条件，调用查询方法
     * @return {*}
     */
    refreshSearch () {
      this.trueFilterParams = JSON.parse(JSON.stringify(this.filterParams));
      this.search();
    },
    /**
     * 初始化数据
     */
    search (_pageNo = 1) {
      /* 处理分页参数 Start */
      this.trueFilterParams.pageSize = this.page.pageSize;
      this.trueFilterParams.pageNo = _pageNo;
      /* 处理分页参数 End */

      this.loading = true;

      pgxmManageService.pgmxQuery(this.xmid, this.trueFilterParams)
        .then(rsp => {
          this.page = Object.assign({}, this.page, rsp.data);
        })
        .catch(err => {
          console.error('信息查询错误', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 重置页面为初始状态
     * @param：
     * @return {*}
     */
    resetForm () {
      this.$refs.filterParams.resetFields();
    },
    /**
     * @description: 分页切换大小
     * @param {number} val
     * @return {*}
     */
    handleSizeChange (val) {
      this.page.pageSize = val;
      this.search();
    }

  },
  created () {
    this.xmid = this.$route.params.id;
    if (this.dlParams.zt) {
      this.filterParams.pgzt = this.dlParams.zt;
    }
    this.refreshSearch();
  }
};

</script>
<style scoped>
  .o-form-btns{
    display: flex;
    align-items: center;
    padding-left: 10px;
  }
</style>
